import { useQuery } from '@tanstack/react-query'
import { getWebsiteThemeById } from 'src/editor/api/website-themes-api'
import { WebsiteThemeInterface } from 'src/editor/store/website-settings/website-settings-types'

export const useWebsiteTheme = (id: number) => {
  return useQuery<WebsiteThemeInterface, Error>({
    queryKey: ['websiteTheme', id],
    queryFn: () => getWebsiteThemeById(id),
    staleTime: 1000 * 60 * 5,
    enabled: !!id,
  })
}
